<div class="prechecks-wizard-page">
    <avi-alert-group
        alertType="danger"
        *ngIf="preCheckState === upgradeFsmState.ERROR"
    >
        <div class="prechecks-wizard-page__alert">
            <span class="prechecks-wizard-page__alert-text">
                {{ l10nKeys.preCheckFailureMessage | vtranslate : ( preCheckEndTime | aviDate ) }}
            </span>

            <a
                href=""
                class="prechecks-wizard-page__alert-link"
                (click)="redirectToReportsPage($event)"
            >
                {{ l10nKeys.goToReportLabel | vtranslate }}
            </a>
        </div>
    </avi-alert-group>
    <avi-alert-group
        *ngIf="preCheckState === upgradeFsmState.WARNING"
        alertType="warning"
    >
        <div class="prechecks-wizard-page__alert">
            <span class="prechecks-wizard-page__alert-text">
                {{ l10nKeys.preCheckWarningMessage | vtranslate : ( preCheckEndTime | aviDate ) }}
            </span>

            <a
                href=""
                class="prechecks-wizard-page__alert-link"
                (click)="redirectToReportsPage($event)"
            >
                {{ l10nKeys.goToReportLabel | vtranslate }}
            </a>
        </div>
    </avi-alert-group>
    <avi-alert-group
        *ngIf="preCheckState === upgradeFsmState.SUCCESS"
        alertType="success"
    >
        <div class="prechecks-wizard-page__alert">
            <span class="prechecks-wizard-page__alert-text">
                {{ l10nKeys.preCheckSuccessMessage | vtranslate : version : ( preCheckEndTime | aviDate ) }}
            </span>

            <a
                href=""
                class="prechecks-wizard-page__alert-link"
                (click)="redirectToReportsPage($event)"
            >
                {{ l10nKeys.goToReportLabel | vtranslate }}
            </a>
        </div>
    </avi-alert-group>

    <div *ngIf="preCheckState === upgradeFsmState.IN_PROGRESS">
        <progress-note></progress-note>
        <div class="prechecks-wizard-page__progressbar">
            <avi-progress-bar
                [percentage]="preCheckProgress"
                [hidePercentage]="true"
                [small]="true"
            ></avi-progress-bar>
        </div>
    </div>

    <avi-data-grid
        [config]="selectedNodesGridConfig"
        [rows]="upgradeNodeStatuses"
        class="prechecks-wizard-page__nodes-grid"
    ></avi-data-grid>

    <div class="prechecks-wizard-page__section">
        <div *ngIf="preCheckState !== upgradeFsmState.IN_PROGRESS">
            <prechecks-list-expander [prechecks]="preCheckList"></prechecks-list-expander>
        </div>
    </div>

    <div class="prechecks-wizard-page__section">
        <h6>{{ l10nKeys.transcriptLabel | vtranslate }}</h6>
        <avi-textarea-container>
            <textarea
                clrTextarea
                [ngModel]="transcript"
                name="upgrade-transcript"
                class="prechecks-wizard-page__transcript-textarea"
                readonly
            ></textarea>
        </avi-textarea-container>
    </div>
</div>
